import {useEffect, useState} from 'react';
import {getPublicCBSectors} from 'api/certification-bodies';
import {alertByError} from 'utils/alerts';

function useGetCBSectors(cbId, abId) {
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);
  const [meta, setMeta] = useState({});

  // For every onChange of menu, this will trigger a reload
  useEffect(() => {
    if (!!abId) {
      setData([]);
      setMeta({});
      getData();
    }
  }, [abId]);

  async function getData(offset = 0) {
    setIsLoading(true);
    try {
      const {data, meta} = await getPublicCBSectors(cbId, {
        accreditation_bodies_id: abId,
        limit: 50,
        offset,
      });

      setData((prev) => [...prev, ...data]);
      setMeta(meta);
    } catch (e) {
      alertByError(e);
    } finally {
      setIsLoading(false);
    }
  }

  return {
    data,
    meta,
    isLoading,
    reload: getData,
  };
}

export default useGetCBSectors;
